import { Flex, Tag } from '@pinchenterprisesnpm/friday-ui'
import styled from 'styled-components'

export const RadioButtonContainer = styled(Flex)`
  gap: ${({ theme: { mp } }) => mp.sm};
  flex-direction: column;
`
export const TitleWithTagRow = styled(Flex)`
  align-items: baseline;
`

export const NewTag = styled(Tag)`
  line-height: 1;
`
// New wrapper styled component for the card border/background
export const CardRadioWrapper = styled(Flex)<{ selected?: boolean }>`
  flex-direction: column;
  border: 1px solid
    ${({ selected, theme: { palette } }) => (selected ? palette.primary : palette.border)};
  border-radius: 3px;
  background: ${({ theme: { palette } }) => palette.white};
  padding: ${({ theme: { mp } }) => mp.sm};
  margin-bottom: ${({ theme: { mp } }) => mp.sm};
  margin-left: ${({ theme: { mp } }) => mp.sm};
  transition: border 0.2s, box-shadow 0.2s;
  gap: ${({ theme: { mp } }) => mp.md};
  &:hover {
    border: 1px solid ${({ theme: { palette } }) => palette.primary};
  }
`

// Add a styled wrapper for the dropdown
export const DropdownWrapper = styled.div`
  margin-top: -1em;
  margin-bottom: -1em;
  max-width: 100%;
`

// Add a styled wrapper for the tags container
export const TagsContainer = styled(Flex)`
  gap: ${({ theme: { mp } }) => mp.sm};
  flex-wrap: wrap;
  margin-bottom: ${({ theme: { mp } }) => mp.xs};
  margin-top: ${({ theme: { mp } }) => mp.xs};
`

export const CardRadioLabel = styled(Flex)<{ selected?: boolean }>`
  align-items: center;
  border: 0px solid
    ${({ selected, theme: { palette } }) => (selected ? palette.primary : palette.border)};
  background: ${({ theme: { palette } }) => palette.white};
  padding: ${({ theme: { mp } }) => mp.sm};
  cursor: pointer;
  gap: ${({ theme: { mp } }) => mp.md};
`

export const CardRadioContent = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme: { mp } }) => mp.xs};
  margin-top: -0.5em;
`

export const CardRadioInput = styled.input`
  accent-color: ${({ theme: { palette } }) => palette.primary};
  margin: 0;
  width: 1.3em;
  height: 1.3em;
  pointer-events: none;
`
